import React, { useRef } from "react";
import { H2, H3 } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { MetaPrimaryText, MetaPrimaryTextHandle } from "../../elements/MetaWizard/MetaPrimaryText";

const MetaAssets = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Assets Page" });
  const metaPrimaryTextRef = useRef<MetaPrimaryTextHandle>(null);

  return (
    <div>
      <div style={{ marginBottom: "24px " }}>
        <H2>{t("Meta assets")}</H2>
      </div>
      <div style={{ marginBottom: "16px " }}>
        <H3>{t("Primary text heading")}</H3>
      </div>
      <MetaPrimaryText ref={metaPrimaryTextRef} settingsMode={true} />
    </div>
  );
};

export default MetaAssets;
